import React, { CSSProperties } from 'react';

import * as S from './styled';
import Icon from '../../../../../../components/Icon';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import ReusableDivider from '../../../../../../reusables/Divider';

interface IProps {
  data: any;
  style?: CSSProperties;
}

const CardHeader = ({ data, style }: IProps) => (
  <S.CardHeader style={{ ...style }}>
    <ReusableDivider style={{ marginTop: '0px' }}>
      <div className="s-divider">
        <img
          style={{ marginRight: 6 }}
          className="PR"
          src={moneyIcon}
          alt="IconPushpin"
        />
        <p>
          Costo: <b>S/.{data?.amount}.00</b> <span>por ciclo</span>
        </p>
      </div>
      |
      <div className="s-divider">
        <Icon name="clock" size={14} />
        <p>{data?.duration}</p>
      </div>
    </ReusableDivider>
  </S.CardHeader>
);

export default CardHeader;
